import { render, staticRenderFns } from "./ArchiveIcon.vue?vue&type=template&id=5d12d846&scoped=true&"
import script from "./ArchiveIcon.vue?vue&type=script&lang=js&"
export * from "./ArchiveIcon.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveIcon.vue?vue&type=style&index=0&id=5d12d846&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d12d846",
  null
  
)

export default component.exports